import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import CategoryService from "./categoryService";
import { AddCategoryDTO , EditCategoryDTO } from "../../dtos/category";
import { PaginationDTO } from "../../dtos/manufacturer";

// Define initial state
const initialState = {
  categoryDetails: [],
  editCategoryPayload: null,
  categoryId: "",
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: <any>"",

  isCategoryLoading: false,
  isEditCategoryLoading: false,

  isEditCategorySuccess: false,

  isCategoryLoadingError: false,
  isEditCategoryLoadingError: false,

  regEditCategoryMessage: "",
};

export const AddCategory = createAsyncThunk(
  "/api/pharmacy/category/add",
  async (category: AddCategoryDTO, thunkAPI) => {
    try {
      return await CategoryService.AddCategory(category);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const EditedCategory = createAsyncThunk(
  "/api/pharmacy/category/edit",
  async (editCategory: EditCategoryDTO, thunkAPI) => {
    try {
      return await CategoryService.editedCategory(editCategory);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getCategoryData = createAsyncThunk(
  "category/getCategoryData", 
  async (dto:PaginationDTO | undefined, thunkAPI) => {
    try {
      const response = await CategoryService.getCategory(dto); 
      return response.data; 
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const categorySlice = createSlice({
  name: "categorySlice",
  initialState,
  reducers: {
    reset: () => initialState,
    changeCategoryId: (state, action) => {
      state.categoryId = action.payload.category;
    },
  },

  extraReducers: (builder) => {
    builder

    .addCase(EditedCategory.pending, (state) => {
      state.isEditCategoryLoading = true;
    })
    .addCase(
      EditedCategory.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.isEditCategoryLoading = false;
        state.isEditCategorySuccess = true;
        state.isEditCategoryLoadingError = false;
        state.regEditCategoryMessage = "";
        state.editCategoryPayload = action.payload;
      }
    )
    .addCase(
      EditedCategory.rejected,
      (state, action: PayloadAction<any>) => {
        state.isEditCategoryLoading = false;
        state.isEditCategoryLoadingError = true;
        state.regEditCategoryMessage = action.payload;
      }
    )
      .addCase(getCategoryData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCategoryData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.categoryDetails = action.payload.category;
        state.message = "";
      })
      .addCase(getCategoryData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });


  },
});

// Export actions and reducer
export const { reset, changeCategoryId } = categorySlice.actions;
export default categorySlice.reducer;
